// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3iVnU","content":"ManualTimeModal_content__1X2rZ"};